import _extends from "@babel/runtime/helpers/esm/extends";
var _IconFreeGifts;
// @ts-nocheck
// import Modules
import React, { useEffect, useState, createElement as _createElement } from 'react';
import { Box, Link, useMediaQuery } from '@mui/material';
import Typography from "../../atoms/Typography";
import Container from "../../atoms/Container";
import QuantityCard from "../../molecules/QuantityCard";
import SummaryCard from "./SummaryCard";
import Button from "../../atoms/Button";
import { IconClose, IconFreeGifts, IconLoading } from "../../atoms/Icon";
import { formatCurrency, formatCurrencyForTcKo } from "../../utils";
// import Styles
import colors from "../../theme/colors";

// import Types
import ModalSoldOut from "./CartSoldOutModal";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let loadTimeout;
// const counterClickDelete = 0;

/**
 * * Temporarily hidden
 * Use to calculate total order amount
 * @param data
 * @returns
 */
const calculateTotal = data => {
  const total = data?.reduce((prev, item) => prev + (item?.originalPrice ?? 0) * (item?.quantity ?? 0), 0);
  return parseFloat(total.toFixed(2)); // Keeps two decimal places and converts it back to number
};

/**
 * * Temporarily hidden
 * Use to calculate the total discount amount of the order
 * @param data
 * @returns
 */
const calculateDiscount = data => {
  // return data?.reduce((prev, item) => prev + (((item?.originalPrice ?? 0) * (item?.quantity ?? 0)) - ((item?.promoPrice ?? 0) * (item?.quantity ?? 0))), 0)
  return data?.reduce((prev, item) => prev + (item.promoPrice || item.originalPrice || 1) * (item?.quantity || 1), 0);
};
const EstoreCartDetail = props => {
  const {
    title,
    counterItemText,
    counterItemsText,
    counterItemTextEnd,
    quantityCard,
    summaryCard,
    emptyCard,
    undoNotice,
    freeGifts,
    onClickedDelete = () => {},
    onUpdateQuantity = () => {},
    toastMessage,
    onShowToastMessage = () => {},
    onUndoItemToCart = () => {},
    onClickedCheckoutButton = () => {},
    loading = false,
    submitLoading = false,
    modalSoldOut = {
      open: false,
      onClose: () => {},
      listItems: [],
      buttonProps: {
        label: '',
        variant: '',
        href: '/'
      },
      locale: '',
      title: ''
    },
    currencySymbol = 'S$',
    titleTaxForTC,
    locale
  } = props;
  const [cards, setCards] = useState(quantityCard);
  const [openUndo, setOpenUndo] = useState(false);
  const [undoActive, setUndoActive] = useState(false);
  const [soldoutAlert, setSoldoutAlert] = useState(false);
  const [counterItem, setCounterItem] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [clickedRemoveItemFlag, setClickedRemoveItemFlag] = useState(false);
  const [discountAmount, setDiscountAmount] = useState(0);
  // const prevCards = useRef<IQuantityCard[] | null>(cards)
  const isMobile = useMediaQuery(themes => themes.breakpoints.down('md'));

  // Update cards
  useEffect(() => {
    setCards(quantityCard || null);
  }, [quantityCard]);

  // Calculate total when list card changes
  useEffect(() => {
    if (cards) {
      setTotalAmount(calculateTotal(cards));
      setDiscountAmount(calculateDiscount(cards));
    }
  }, [cards]);

  // Checking inventory_level and checking total number of items => disable checkout button and show toast message
  useEffect(() => {
    const soldout = cards?.find(item => item?.inventory_level === 0 || item?.quantity > item?.inventory_level);
    setCounterItem(cards?.reduce((init, current) => {
      return init + (current?.quantity ?? 1);
    }, 0) ?? 0);
    if (soldout) {
      setSoldoutAlert(true);
      onShowToastMessage(true);
    } else {
      setSoldoutAlert(false);
      onShowToastMessage(false);
    }
  }, [cards, onShowToastMessage]);

  // Use to delete item in cards after clicking recycle icon
  const handleRemoveItem = id => {
    setClickedRemoveItemFlag(!clickedRemoveItemFlag);
    onClickedDelete(id);
    if (cards?.length && !loading) {
      setOpenUndo(true);
    }
  };

  // After setting dropdown quantity => update cards
  const onSetQuantity = (id, quantity, productId) => {
    onUpdateQuantity(id, quantity, productId);
  };

  // Handle after clicked checkout button
  const onClickCheckout = () => {
    onClickedCheckoutButton(cards);
  };

  // Undo clicked => update cards and disable undo notice
  useEffect(() => {
    clearTimeout(loadTimeout);
    if (undoActive) {
      // setCards(prevCards.current)
      setOpenUndo(false);
    }
  }, [undoActive]);

  // Any changes to open undo => should turn off undoActive and clearTimeout if openUndo does not appear
  useEffect(() => {
    clearTimeout(loadTimeout);
    if (openUndo) {
      loadTimeout = setTimeout(() => {
        setOpenUndo(false);
      }, 5000);
      setUndoActive(false);
    }
  }, [openUndo, clickedRemoveItemFlag]);

  // Scroll to freegift list card
  const handleScrollTo = () => {
    if (typeof window !== "undefined") {
      const itemView = document.getElementById('free-gift-items');
      if (itemView) {
        const {
          offsetTop
        } = itemView;
        window.scrollTo({
          top: offsetTop + 200,
          behavior: 'smooth'
        });
      }
    }
  };
  const renderUndoToast = () => {
    return /*#__PURE__*/_jsxs(Box, {
      className: "undo-replacer",
      sx: {
        transition: 'all .2s ease',
        background: '#E600001A',
        width: '100%',
        borderRadius: !isMobile ? '10px' : '0px',
        padding: !openUndo ? '0px' : '14px 32px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: !openUndo ? '0px' : {
          xs: '48px',
          md: '50px'
        },
        '& p': {
          margin: '0px'
        }
      },
      children: [/*#__PURE__*/_jsxs(Box, {
        sx: {
          display: openUndo ? 'flex' : 'none',
          gap: '12px'
        },
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "p6",
          sx: {
            color: colors.primary.bandaiNamcoBlack,
            marginBottom: {
              xs: '8px',
              lg: '52px'
            }
          },
          children: undoNotice?.describe
        }), /*#__PURE__*/_jsx(Link, {
          href: "/",
          component: "button",
          variant: "body2",
          onClick: () => {
            setUndoActive(true);
            onUndoItemToCart();
          },
          sx: {
            '&,&:hover': {
              textDecorationColor: colors.neutral.neutral1,
              textUnderlineOffset: '5px'
            }
          },
          children: /*#__PURE__*/_jsx(Typography, {
            variant: "p5",
            sx: {
              color: colors.neutral.neutral1,
              marginBottom: {
                xs: '8px',
                lg: '52px'
              }
            },
            children: undoNotice?.undoLink
          })
        })]
      }), /*#__PURE__*/_jsx(IconClose, {
        onClick: () => {
          setOpenUndo(false);
        },
        sx: {
          cursor: 'pointer',
          width: '16px',
          height: '16px'
        }
      })]
    });
  };
  const renderFreegiftToast = () => {
    return /*#__PURE__*/_jsxs(Box, {
      className: "free-gifts",
      sx: {
        background: '#00B0B81A',
        width: '100%',
        borderRadius: '10px',
        padding: '14px 32px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: {
          xs: '48px',
          md: '50px'
        },
        '& p': {
          margin: '0px'
        }
      },
      children: [/*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          gap: '12px',
          alignItems: 'center',
          'svg': {
            width: '16px',
            height: '16px'
          }
        },
        children: [_IconFreeGifts || (_IconFreeGifts = /*#__PURE__*/_jsx(IconFreeGifts, {})), /*#__PURE__*/_jsx(Typography, {
          variant: "p6",
          sx: {
            color: colors.primary.bandaiNamcoBlack,
            marginBottom: {
              xs: '8px',
              lg: '52px'
            }
          },
          children: freeGifts?.describe
        })]
      }), /*#__PURE__*/_jsx(Box, {
        onClick: () => handleScrollTo(),
        sx: {
          cursor: 'pointer',
          '&,&:hover': {
            textDecorationColor: colors.neutral.neutral1,
            textUnderlineOffset: '5px'
          }
        },
        children: /*#__PURE__*/_jsx(Typography, {
          variant: "p5",
          sx: {
            color: colors.neutral.neutral1,
            textDecoration: 'underline',
            marginBottom: {
              xs: '8px',
              lg: '52px'
            }
          },
          children: freeGifts?.linkTo?.label
        })
      })]
    });
  };
  const renderToastMessage = () => {
    return /*#__PURE__*/_jsx(Box, {
      sx: {
        display: openUndo || soldoutAlert || !!freeGifts?.listCards?.length ? 'block' : 'none',
        marginBottom: '40px',
        marginTop: '0px',
        padding: openUndo && '0px' || soldoutAlert && '14px 18px' || '0px',
        backgroundColor: openUndo && 'transparent' || soldoutAlert && '#E600001A' || 'transparent',
        borderRadius: !isMobile && soldoutAlert ? '10px' : '0px',
        fontSize: {
          xs: "14px",
          md: "16px"
        },
        lineHeight: {
          xs: "20px",
          md: "22px"
        }
      },
      children: openUndo && !loading && renderUndoToast() || soldoutAlert && toastMessage || !!freeGifts?.listCards?.length && renderFreegiftToast()
    });
  };

  /**
   * Loading Template
   */
  if (!cards) {
    return /*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsxs(Container, {
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h1",
          sx: {
            color: colors.primary.bandaiNamcoBlack,
            marginBottom: '44px'
          },
          children: title
        }), /*#__PURE__*/_jsx(Box, {
          sx: {
            textAlign: 'center',
            padding: {
              xs: '50px',
              md: '100px'
            }
          },
          children: /*#__PURE__*/_jsx(IconLoading, {
            htmlColor: colors.primary.bandaiNamcoRed
          })
        })]
      })
    });
  }

  /**
   * Empty Cards Template
   */
  if (cards?.length === 0) {
    return /*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsxs(Container, {
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h1",
          sx: {
            color: colors.primary.bandaiNamcoBlack,
            marginBottom: cards?.length ? {
              xs: '8px',
              lg: '44px'
            } : ''
          },
          children: title
        }), /*#__PURE__*/_jsxs(Box, {
          sx: {
            textAlign: 'center',
            marginTop: {
              xs: '64px',
              md: '112px'
            }
          },
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "h4",
            sx: {
              color: colors.primary.bandaiNamcoBlack,
              marginBottom: {
                xs: '4px',
                md: '8px'
              }
            },
            children: emptyCard?.title
          }), /*#__PURE__*/_jsx(Typography, {
            variant: "p6",
            sx: {
              color: colors.primary.bandaiNamcoBlack,
              marginBottom: {
                xs: '20px',
                md: '48px'
              }
            },
            children: emptyCard?.description
          }), /*#__PURE__*/_jsx(Box, {
            sx: {
              width: '148px',
              margin: '0 auto',
              display: {
                md: 'block'
              },
              marginTop: {
                md: '52px'
              }
            },
            children: /*#__PURE__*/_jsx(Button, {
              fullWidth: true,
              variant: "primaryDark",
              label: emptyCard?.button?.label,
              target: "_parent",
              externalLink: emptyCard?.button?.externalLink
            })
          })]
        })]
      })
    });
  }
  return /*#__PURE__*/_jsxs(Box, {
    children: [/*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "h1",
        sx: {
          color: colors.primary.bandaiNamcoBlack,
          marginBottom: cards?.length ? {
            xs: '8px',
            lg: '44px'
          } : ''
        },
        children: title
      }), counterItem > 0 && /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: {
            xs: 'flex',
            lg: 'none'
          },
          gap: '21px',
          marginBottom: '52px'
        },
        children: [/*#__PURE__*/_jsxs(Typography, {
          variant: "p4",
          sx: {
            color: colors.primary.bandaiNamcoBlack,
            paddingRight: '21px',
            borderRight: '1px solid black'
          },
          children: [["tc"].includes(`${locale}`.toLowerCase()) ? `${counterItemText}${counterItem}${counterItemTextEnd}` : "", ["ko-kr"].includes(`${locale}`.toLowerCase()) ? `${counterItemText} ${counterItem} ${counterItemTextEnd}` : "", !["ko-kr", "tc"].includes(`${locale}`.toLowerCase()) ? `${counterItem} ${counterItem === 1 ? counterItemText : counterItemsText}` : ""]
        }), /*#__PURE__*/_jsx(Typography, {
          variant: "h6",
          sx: {
            color: colors.primary.bandaiNamcoBlack
          },
          children:
          // eslint-disable-next-line no-nested-ternary
          ["tc"].includes(`${locale}`.toLowerCase()) ? `${currencySymbol}${formatCurrencyForTcKo(totalAmount)}` : ["ko-kr"].includes(`${locale}`.toLowerCase()) ? `${formatCurrencyForTcKo(totalAmount)}${currencySymbol}` : `${currencySymbol}${formatCurrency(totalAmount, 2)}`
        })]
      })]
    }), isMobile && renderToastMessage(), /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          justifyContent: 'space-between',
          position: 'relative',
          gap: {
            xs: '56px'
          },
          flexDirection: {
            xs: 'column',
            lg: 'row'
          }
        },
        children: [/*#__PURE__*/_jsxs(Box, {
          sx: {
            flex: {
              xs: '1',
              lg: '1 1 665px'
            },
            background: loading ? 'white' : 'unset',
            opacity: loading ? 0.5 : 1
          },
          children: [!isMobile && renderToastMessage(), /*#__PURE__*/_jsxs(Box, {
            sx: {
              display: 'flex',
              flexDirection: 'column',
              width: '100%'
            },
            children: [/*#__PURE__*/_jsxs(Box, {
              sx: {
                display: 'flex',
                flexDirection: 'column',
                marginBottom: {
                  xs: freeGifts?.listCards?.length ? '56px' : '0px',
                  lg: '108px'
                },
                gap: {
                  xs: '48px',
                  lg: '70px'
                },
                width: '100%',
                position: 'relative'
              },
              children: [loading && /*#__PURE__*/_jsx(Box, {
                sx: {
                  position: 'absolute',
                  zIndex: 100,
                  left: '50%',
                  top: '200px'
                },
                children: /*#__PURE__*/_jsx(IconLoading, {
                  htmlColor: colors.primary.bandaiNamcoRed
                })
              }), cards?.map(item => {
                return /*#__PURE__*/_createElement(QuantityCard, _extends({}, item, {
                  currencySymbol: currencySymbol,
                  key: item?.productId ?? item?.id,
                  setMaxQuantity: item?.inventory_level,
                  onClickDelete: handleRemoveItem,
                  onSetQuantity: onSetQuantity,
                  locale: locale
                }));
              })]
            }), !!freeGifts?.listCards?.length && /*#__PURE__*/_jsxs(Box, {
              sx: {
                display: 'flex',
                flexDirection: 'column',
                width: '100%'
              },
              children: [/*#__PURE__*/_jsx(Typography, {
                variant: "h6",
                sx: {
                  color: colors.primary.bandaiNamcoBlack,
                  marginBottom: '44px'
                },
                children: freeGifts?.title
              }), /*#__PURE__*/_jsx(Box, {
                id: "free-gift-items",
                sx: {
                  display: 'flex',
                  flexDirection: 'column',
                  color: colors.primary.bandaiNamcoBlack,
                  gap: {
                    xs: '48px',
                    lg: '70px'
                  }
                },
                children: freeGifts?.listCards?.map(item => {
                  return /*#__PURE__*/_createElement(QuantityCard, _extends({}, item, {
                    currencySymbol: currencySymbol,
                    key: item?.productId ?? item?.id,
                    variant: "freegifts",
                    locale: locale
                  }));
                })
              })]
            })]
          })]
        }), /*#__PURE__*/_jsx(Box, {
          sx: {
            flex: {
              xs: '1',
              lg: '1 1 357px'
            }
          },
          children: /*#__PURE__*/_jsx(Box, {
            sx: {
              position: 'sticky',
              top: '100px',
              bottom: 0
            },
            children: /*#__PURE__*/_jsx(SummaryCard, _extends({}, summaryCard, {
              totalAmount: totalAmount,
              discount: discountAmount,
              disabled: soldoutAlert,
              quantity: counterItem,
              onClickedCheckoutButton: onClickCheckout,
              submitLoading: submitLoading,
              currencySymbol: currencySymbol,
              titleTaxForTC: titleTaxForTC,
              locale: locale
            }))
          })
        })]
      })
    }), /*#__PURE__*/_jsx(ModalSoldOut, _extends({}, modalSoldOut, {
      title: modalSoldOut?.title ?? '',
      currencySymbol: currencySymbol,
      locale: locale || ""
    }))]
  });
};
export default EstoreCartDetail;